export default "__VITE_ASSET__C2xq$Vy___"